const EbayTypes = {
  FETCH_EBAY_STATUS_REQUEST: "FETCH_EBAY_STATUS_REQUEST",
  FETCH_EBAY_STATUS_SUCCESS: "FETCH_EBAY_STATUS_SUCCESS",
  FETCH_EBAY_STATUS_FAILURE: "FETCH_EBAY_STATUS_FAILURE",
};

export default EbayTypes;
